import React from 'react';
import Svg from 'rp-react-svg-icon';
import { compose, setDisplayName } from 'recompose';
import classnames from 'classnames';
import baseStyles from '../EmailConfirmationPage.scss';

export const EmailConfirmationSuccess = () => (
  <div>
    <h2 className={baseStyles.title}>Verification complete</h2>
    <p className={baseStyles.paragraph}>
        You have successfully verified your email address. You can now sign in to your Racing Post account.
    </p>
    <Svg
      iconName="tick"
      className={classnames('ui-icon', 'ui-icon_size3XL', baseStyles.icon)}
        />
  </div>
);

export default compose(setDisplayName('EmailConfirmationSuccess'))(EmailConfirmationSuccess);
